/* eslint-disable react/forbid-dom-props */
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

/** @namespace Theme/Component/MenuIcon/Component */
export class MenuIconComponent extends PureComponent {
    static propTypes = {
        isActive: PropTypes.bool,
    };

    static defaultProps = {
        isActive: false,
    };

    render() {
        const { isActive } = this.props;

        return (
            <svg
              block="MenuIcon"
              mods={ { isActive } }
              width="22"
              height="12"
              viewBox="0 0 22 12"
              fill="#fff"
              stroke="#fff"
              strokeWidth="2px"
              strokeLinecap="round"
              xmlns="http://www.w3.org/2000/svg"
            >
                <g transform="translate(-323.5 -28.5)">
                    <line className="a" x2="20" transform="translate(324.5 29.5)" />
                    <line className="a" x2="20" transform="translate(324.5 34.5)" />
                    <line className="a" x2="20" transform="translate(324.5 39.5)" />
                </g>
            </svg>
        );
    }
}

export default MenuIconComponent;
